import sanitizeHtml from 'sanitize-html'

const sanitizeConfig = {
  allowedTags: [
    'b',
    'i',
    'em',
    'strong',
    'a',
    'div',
    'span',
    'img',
    'ol',
    'ul',
    'li',
    'br',
    'p',
    'sup',
  ],

  allowedAttributes: {
    a: ['href', 'target'],
    img: ['src'],
  },
  allowedSchemes: ['http', 'https'],
  allowedSchemesAppliedToAttributes: ['src'],
  allowProtocolRelative: false,
}

const sanitizeHTMLContent = (dirtyHTML) => {
  // Adding protocol to links if it is missing
  const protocolPattern = /^(http|https):\/\//i
  if (global.window) {
    const div = document?.createElement('div')
    div.innerHTML = dirtyHTML
    const links = div.getElementsByTagName('a')

    Array.from(links).forEach((link) => {
      const href = link?.getAttribute('href')
      if (href && !protocolPattern.test(href)) {
        link?.setAttribute('href', `https://${href}`)
      }
    })

    return sanitizeHtml(div.innerHTML, sanitizeConfig)
  }

  return null
}

export default sanitizeHTMLContent
